import React, { useState } from "react";
import { Form, Input } from "antd";
// import { macValidator } from "../../utils/macValidator";

const { TextArea } = Input;

const CustomTextArea = ({
  disable,
  label,
  name,
  defaultValue,
  errorMessage,
  required,
  placeholder,
  rows,
  maxLength,
  rules = [],
  onChange,
  ...rest
}) => {
  const [macCount, setMacCount] = useState(0);

  // Check if this is a MAC address field
  const isMacField = name === "Mac" || label?.toLowerCase().includes("mac");

  // Function to parse MAC addresses from text
  const parseMacAddresses = (text) => {
    if (!text) return [];

    // Split by common separators (newlines, commas, semicolons, spaces)
    const addresses = text
      .split(/[\n,;\s]+/)
      .map((addr) => addr.trim().toUpperCase())
      .filter((addr) => addr.length > 0);

    return addresses;
  };

  // Function to validate MAC addresses and detect duplicates
  const validateMacAddresses = (text) => {
    const addresses = parseMacAddresses(text);

    setMacCount(addresses.length);
  };

  // Custom onChange handler for MAC validation
  const handleChange = (e) => {
    const value = e.target.value;

    if (isMacField) {
      validateMacAddresses(value);
    }

    // Call the original onChange if provided
    if (onChange) {
      onChange(e);
    }
  };

  // Combine error messages
  const combinedError = errorMessage;

  const defaultRules = [
    {
      required: required,
      message: `${label} is required`,
    },
    ...(isMacField
      ? [
          {
            validator: (_, value) => {
              if (!value) return Promise.resolve();

              const addresses = parseMacAddresses(value);

              const macRegex = /^([0-9A-Fa-f]{2}:){5}[0-9A-Fa-f]{2}$/;

              const invalids = addresses.filter((addr) => !macRegex.test(addr));

              if (invalids.length > 0) {
                return Promise.reject(
                  new Error(`Invalid MAC address(es): ${invalids.join(", ")}`)
                );
              }

              return Promise.resolve();
            },
          },
        ]
      : []),
  ];

  return (
    <div className="relative">
      <Form.Item
        label={
          required ? (
            <span>
              {label}
              <span style={{ color: "red" }}>*</span>
            </span>
          ) : (
            label
          )
        }
        className={"mb-2"}
        name={name}
        initialValue={defaultValue}
        rules={rules.length ? rules : defaultRules}
        validateStatus={combinedError ? "error" : ""}
        help={combinedError}
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        required={false}
      >
        <TextArea
          disabled={disable}
          placeholder={placeholder ?? `Enter ${label}`}
          rows={rows}
          maxLength={maxLength}
          onChange={handleChange}
          {...rest}
        />
      </Form.Item>

      {isMacField && (
        <div
          style={{
            marginTop: "4px",
            fontSize: "12px",
            color: "#666",
            textAlign: "right",
          }}
          className="absolute right-0 top-0 mr-2 mt-2"
        >
          <span>MAC addresses: {macCount}</span>
        </div>
      )}
    </div>
  );
};

export default CustomTextArea;
